import { getApiUrl } from "@utils/baseUrl";
import axios from "axios";
import type { ProductSearchData, ProductSearchHistoryResponse, SaveSearchApiResponse } from "./types";

const productSearchHistoryAPI = {
  userDashboard: getApiUrl("userDashboard"),
  saveSearch: getApiUrl("saveSearch"),
  deleteSavedSearchByName: getApiUrl("deleteSavedSearchByName"),
};

export const getProductSearchHistory = async (): Promise<ProductSearchHistoryResponse> => {
  const { data } = await axios.post(productSearchHistoryAPI.userDashboard, {
    section_type: "user_history",
    search_source: "product_search",
  });
  return data;
};

export type SaveProductSearchPayload = {
  search_name: string;
  search_category: string;
  trade_direction?: string;
  url: string;
  search_data: ProductSearchData;
};

export const saveProductSearch = async (payload: SaveProductSearchPayload): Promise<SaveSearchApiResponse> => {
  const { data } = await axios.post(productSearchHistoryAPI.saveSearch, { ...payload, source: "product_search" });
  return data;
};

export const deleteSavedSearchById = async (id: number | string): Promise<SaveSearchApiResponse> => {
  const { data } = await axios.post(productSearchHistoryAPI.deleteSavedSearchByName, { id });
  return data;
};
